// src/flows/masterclass/Step2_ModeSelection.tsx
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useProgramCreation } from '../ProgramCreationContext';
import DosenButton from '../../../ui/Buttons/DosenButton';

export function Step2_ModeSelection() {
  const navigate = useNavigate();
  const { state, dispatch } = useProgramCreation();

  const resetFlowState = () => {
    localStorage.removeItem('programCreation');
    dispatch({ type: 'RESET_KEEP_PROGRAM_TYPE', payload: { programType: state.programType } });
  };

  const selectAI = () => {
    resetFlowState();
    dispatch({ type: 'SET_BUILD_MODE', payload: 'ai' });
    navigate('../ai/purpose');
  };

  const selectManual = () => {
    resetFlowState();
    dispatch({ type: 'SET_BUILD_MODE', payload: 'manual' });
    navigate('../manual');
  };

  return (
    <Box
      width="100%"
      height="100%"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      p={8}
      gap={8}
    >
      <Box width={600} display="flex" flexDirection="column" alignItems="center" gap={4}>
        <Typography textAlign="center" sx={{ color: '#FDFDFD', fontSize: 30, fontWeight: 500 }}>
          How do you want to build your Program?
        </Typography>

        <Box width={300} display="flex" flexDirection="column" gap={2}>
          {/* Build with AI */}
          <Button
            fullWidth
            onClick={selectAI}
            sx={{
              background: 'linear-gradient(180deg, #F79420 0%, #F15A26 100%)',
              borderRadius: 1,
              color: '#FDFDFD',
              fontWeight: 600,
              py: 1.8,
              '&:hover': {
                opacity: 0.9
              }
            }}
          >
            Build with AI
          </Button>

          {/* Build Manually */}
          <Button
            fullWidth
            onClick={selectManual}
            sx={{
              background: '#565656',
              border: '1px solid #0F0F0F',
              borderRadius: 1,
              color: '#FDFDFD',
              fontWeight: 500,
              py: 1.8,
              '&:hover': { background: '#6A6A6A' }
            }}
          >
            Build Manually
          </Button>

          {/* Coming Soon */}
          <DosenButton
            fullWidth
            disabled
            locked
            sx={{
              background: '#3A3A3A',
              border: '1px solid #0F0F0F',
              borderRadius: 1,
              color: '#9B9B9B',
              fontWeight: 500,
              py: 1.8,
              cursor: 'not-allowed'
            }}
          >
            Use Template
          </DosenButton>
        </Box>
      </Box>
    </Box>
  );
}
